import { useMemo } from "react";
import { OWN_SCREENS, screenOn, type OwnScreenId } from "../../shared/screens";
import { useAtlasSettings } from "../atlas/atlasQueries";
import { useHousehold } from "./useHousehold";

/**
 * Which screens are on (Admin → Screens & schedule). Own screens by id,
 * layouts by layout id; the Living Atlas keeps its own master switch.
 */
export function useScreens() {
  const { settings } = useHousehold();
  const atlasOn = useAtlasSettings().settings.enabled;
  const screens = settings.screens;
  return useMemo(() => {
    const isOn = (id: string) => (id === "atlas" ? atlasOn : screenOn(screens, id));
    const offOwn = OWN_SCREENS.filter((s) => !isOn(s.id)).map((s) => s.id as OwnScreenId);
    /** Query keys of screens that are off: the wall drops them and doesn't refresh them. */
    const offQueryKeys = OWN_SCREENS.filter((s) => !isOn(s.id)).flatMap((s) => s.queryKeys);
    return { isOn, offOwn, offQueryKeys };
  }, [screens, atlasOn]);
}
